/** Публичная страница, которой нет.
 *
 *  Текст намеренно ничего не сообщает о том, существует ли такая форма и не
 *  отключена ли она: раньше было «не найдена ИЛИ отключена», и это подсказывало
 *  перебирающему, что ссылка угадана верно (Алексей 16.09 — «не пускать людей,
 *  чтобы от хакеров подальше»). Для гостя разницы нет, для чужого — есть.
 */
export default function PublicNotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-2 px-6 text-center">
      <p className="text-lg font-medium text-neutral-700 dark:text-neutral-200">Страница не найдена</p>
      <p className="text-sm text-neutral-500">Проверьте ссылку или QR-код.</p>
    </div>
  );
}
